/**
 * EmbedContainer — Lightweight container for embedded Morpheus widgets.
 *
 * These are standalone pages opened in new tabs from external systems (e.g. Salesforce).
 * They render WITHOUT the full Morpheus shell (no sidebar, no header navigation)
 * but still require authentication.
 *
 * Sub-routes:
 *   /embed/user-insights/:userId — User profile + buying criteria.
 *     :userId is overloaded — accepts either:
 *       A) a numeric user ID           (Salesforce embed)
 *       B) adc:user:phone-{E.164} URN  (Amazon Connect embed; resolved by verified phone)
 *   /embed/loan/:orgId — Loan number encryption widget
 *   /embed/...         — Future embedded widgets
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { NoMatch } from '@adc/ui-morpheus'
import LoanNumberEntry from '../../components/loanNumberEntry'
import UserInsightsPage from './userInsights'

const EmbedContainer = ({ match }) => {
  return (
    <Switch>
      <Route
        path={`${match.url}/user-insights/:userId`}
        component={UserInsightsPage}
      />
      <Route path={`${match.url}/loan/:orgId`} component={LoanNumberEntry} />
      <Route component={NoMatch} />
    </Switch>
  )
}

export default EmbedContainer
